import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  OnInit,
  signal,
} from '@angular/core';
import { SelectComponent } from '../select.component';

@Component({
  selector: 'app-select-option',
  imports: [NgClass],
  templateUrl: './select-option.component.html',
  styleUrl: './select-option.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectOptionComponent implements OnInit {
  public value = input<any>();
  public label = input<string>();
  public selected = model<boolean>(false);
  public disabled = input<boolean>(false);

  public isVisible = signal<boolean>(true);

  private parent = inject(SelectComponent, { optional: true, host: true });

  ngOnInit(): void {
    if (this.selected()) {
      this.parent?.select(this, false);
    }
  }

  protected onClick() {
    if (!this.disabled()) this.parent?.select(this);
  }
}
